import React from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import styled from 'styled-components';
import theme from 'theme/theme';

const StyledLink = styled.a`
    display: flex;
    height: 48px;
    width: 100%;
    align-items: center;
    justify-content: ${ (props) => {
        return props.align;
    } };
    text-decoration: none;
    color: ${ theme.table.body.row.color };

    &:hover {
        text-decoration: none;
        color: ${ theme.table.body.row.color };
        cursor: pointer;
    }
`;

const SingleDataTextField = (props) => {
    const {
        action,
        data,
        formatValue,
        optionValue,
        link,
        record,
        resource,
        searchParams,
        source,
    } = props;

    const formatValueFromProps = (data) => {
        if (formatValue) {
            return formatValue(data);
        }

        return data[optionValue] || data;
    };

    return (
        <SingleDataContainer
            action={ action }
            data={ data }
            id={ record[source] }
            resource={ resource }
            searchParams={ searchParams }
        >
            { ({ data }) => {
                const value = data ? formatValueFromProps(data) : '...';

                if (link) {
                    return (
                        <StyledLink href={ `/${ resource }/${ record[source] }/show` }>
                            <TextField value={ value } />
                        </StyledLink>
                    );
                }

                return (
                    <TextField value={ value } />
                );
            } }
        </SingleDataContainer>
    );
};

SingleDataTextField.defaultProps = {
    link: false,
    optionValue: 'name',
    searchParams: {},
};

SingleDataTextField.propTypes = {
    action: PropTypes.func,
    data: PropTypes.object,
    formatValue: PropTypes.func,
    link: PropTypes.bool,
    optionValue: PropTypes.string.isRequired,
    record: PropTypes.object,
    resource: PropTypes.string,
    searchParams: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
    const { resource, record, source } = props;

    const stateResource = state[resource];
    const id = record[source];

    return {
        data: stateResource.data[id] || null,
    };
};

const enhance = compose(
    connect(mapStateToProps, null),
);

export default enhance(SingleDataTextField);


// WEBPACK FOOTER //
// ./src/components/show/SingleDataTextField.js